module.exports = __webpack_public_path__ + "static/media/photo14.e8ab0c4d.jpg";